export default function About() {
  return (
    <section
      id="about"
      style={{ scrollMarginTop: '80px', backgroundColor: '#ffffff' }}
      className="px-6 pt-20 pb-20 min-h-screen"
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-3">
          <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-ocean-mid/10 to-sunset-coral/10 px-4 py-1 rounded-full mb-2 border border-ocean-mid/20">
            <i className="ri-building-line text-ocean-mid text-xs"></i>
            <span className="text-[11px] font-semibold text-ocean-mid uppercase tracking-wide">About BB Global Financial Administration</span>
          </div>
        </div>

        <div className="bg-white rounded-2xl p-5 shadow-xl border border-ocean-mid/15">
          <div className="flex justify-center mb-4">
            <div className="relative">
              <div className="w-20 h-20 rounded-xl overflow-hidden shadow-lg border-2 border-ocean-mid/20 bg-white flex items-center justify-center p-1.5">
                <img
                  src="https://storage.readdy-site.link/project_files/11bf54dc-cd8b-412f-9383-b1020052ccc0/e790e585-9341-4eda-8466-7e9d89aa3fd5_ChatGPT-Image-Mar-2-2026-12_02_26-PM-ek.png?v=e86025dbcd928cb45795c7555e605914"
                  alt="BB Beyhan Balance Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="absolute -bottom-1.5 -right-1.5 w-7 h-7 bg-gradient-to-br from-ocean-mid to-sunset-coral rounded-full flex items-center justify-center shadow-lg">
                <i className="ri-building-fill text-white text-[10px]"></i>
              </div>
            </div>
          </div>

          <div className="space-y-1.5 text-xs text-gray-700 leading-relaxed">
            <p>
              BB Global Financial Administration is built on more than{' '}
              <strong className="text-ocean-mid">eight years of professional finance experience</strong> across{' '}
              <strong className="text-ocean-mid">Türkiye and the Netherlands</strong>, developed within international business environments.
            </p>
            <p>
              This experience has provided a broad perspective across financial operations, including accounting, reporting cycles, financial administration, internal controls, audit coordination, and operational finance processes. Working within structured corporate environments and international organizations has shaped a strong understanding of how disciplined financial structures support stable and sustainable business growth.
            </p>
            <p className="text-[13px] font-semibold text-ocean-mid">
              Today, I operate as a finance contractor through BB Global Financial Administration, providing short-term, long-term, and permanent financial support to organizations.
            </p>
            <p>
              BB Global Financial Administration supports startups, scale-ups, and established companies by strengthening financial processes, improving operational workflows, and ensuring that accounting and finance activities run smoothly, accurately, and with proper structure.
            </p>
            <p className="text-[13px] font-semibold text-ocean-mid">
              By combining international experience, strong financial discipline, and structured process thinking, BB Global Financial Administration helps organisations maintain clear, well-organised financial operations, allowing leadership teams to focus on growth while financial processes remain controlled, transparent, and reliable.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
